import get from 'lodash/get'

import API from '../../../utils/http/api'

// NOT FILES (They are just strings, Action Types)
const REQUEST = 'sbdata/outcomes/REQUEST'
const SUCCESS = 'sbdata/outcomes/SUCCESS'
const UNIV_INFO_SUCCESS = 'sbdata/outcomes/UNIV_INFO_SUCCESS'
const FAILURE = 'sbdata/outcomes/FAILURE'
const DATA_SUCCESS = 'steppingblocks/outcomes/SUCCESS'
const CLEAR_DIM_NAME = 'steppingblocks/outcomes/CLEAR_DIM_NAME'

// Start reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
  totalCount: 0,
  univData: null,
  univInfo: null,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
        univData: payload,
        totalCount: _state.totalCount === 0 ? payload.totalCount : _state.totalCount,
      }
    case UNIV_INFO_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
        univInfo: payload,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    case CLEAR_DIM_NAME: {
      return {
        ..._state,
        dimName: null,
      }
    }

    default:
      return _state
  }
}

// Start Actions
export const performGetUnivInfo = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get('/outcomes/get-univ-info', params)
    dispatch({ type: UNIV_INFO_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
  }
}

export const performSetDemoClientData = params => async dispatch => {
  dispatch({
    type: DATA_SUCCESS,
    payload: { dimName: get(params, 'dimName') },
  })
}

export const performClearDimMName = () => async dispatch => {
  dispatch({
    type: CLEAR_DIM_NAME,
  })
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Outcomes/outcomesDuck.js